import React from "react";
import { Button, Checkbox, List, ListItem, TextField } from "@mui/material";
import { Audience } from "modules/audiences";
import FilterMoreOptionsButton from "modules/common/components/buttons/filterMoreOptionsButton";
import SearchIcon from "@mui/icons-material/Search";
import { AnalyticsReportFilters } from "modules/insights";
import { ALL_AUDIENCES_SELECTION, DEFAULT_EMPTY_GUID } from "utils/analyticsHelpers";

const AudienceFilters: React.FC<AudienceFiltersProps> = ({
    audiences,
    audienceDropdownText,
    audienceSearchText,
    filters,
    renameEveryoneInternalAudience,
    onChangeAudience,
    onUpdateAudienceTextToSearch,
    onHandleAllAudience,
}) => {
    const getAudienceFilterFooter = () => {
        const audienceSelected = (filters.audiences?.length ?? 0) > 0;

        return (
            <Button color="primary" style={{ float: "right" }} onClick={() => onHandleAllAudience(audienceSelected)}>
                {audienceSelected ? "Unselect" : "Select"} All
            </Button>
        );
    };

    const getAudienceSearchBox = () => (
        <TextField
            variant="outlined"
            size="small"
            fullWidth
            value={audienceSearchText}
            placeholder="Search audience"
            InputProps={{
                startAdornment: <SearchIcon className="search-icon" />,
            }}
            onChange={onUpdateAudienceTextToSearch}
            className="text-to-search"
        />
    );

    const mapAudiences = () => {
        let audiencesToDisplay = [...audiences];

        if (!audienceSearchText && renameEveryoneInternalAudience) {
            audiencesToDisplay.unshift(ALL_AUDIENCES_SELECTION);
        }

        // Sorts the 'everyone audience' to the top.
        const sortedAudiences = audiencesToDisplay.sort((a, b) => {
            if (a.id === DEFAULT_EMPTY_GUID) return -1;
            if (b.id === DEFAULT_EMPTY_GUID) return 1;
            return 0;
        });

        return sortedAudiences.map((audience) => (
            <React.Fragment key={audience.id}>
                <ListItem onClick={() => onChangeAudience(audience.id)} className="select-popover-group-header-clickable">
                    <Checkbox
                        edge="start"
                        tabIndex={-1}
                        disableRipple
                        size="small"
                        color="primary"
                        checked={!!filters.audiences?.find((selectedAudience) => selectedAudience === audience.id)}
                    />
                    <span
                        style={{
                            fontStyle: audience.id === DEFAULT_EMPTY_GUID ? "italic" : "normal",
                        }}
                    >
                        {audience.displayName}
                    </span>
                </ListItem>
            </React.Fragment>
        ));
    };

    return (
        <FilterMoreOptionsButton
            text={audienceDropdownText}
            header={getAudienceSearchBox()}
            footer={getAudienceFilterFooter()}
            className="moreOptionsButton moreOptionsButton-ml"
        >
            <div style={{ height: "254px", width: "350px" }}>
                <List disablePadding>{mapAudiences()}</List>
            </div>
        </FilterMoreOptionsButton>
    );
};

interface AudienceFiltersProps {
    audienceDropdownText: string;
    audiences: Audience[];
    audienceSearchText: string;
    filters: Partial<AnalyticsReportFilters>;
    renameEveryoneInternalAudience?: string;
    onChangeAudience: (audienceId: string) => void;
    onUpdateAudienceTextToSearch: (ev: React.ChangeEvent<HTMLInputElement>) => void;
    onHandleAllAudience: (audienceSelected: boolean) => void;
}

export default AudienceFilters;
